import { all } from 'redux-saga/effects';
import app from './app';
import applicant from './applicant';
import { issuers } from './issuers';
import { policies } from './policies';

export default function* rootSaga() {
  yield all([app(), applicant(), issuers(), policies()]);
}
